import { api } from '../services/api'

export interface IdentityStatus {
  verified: boolean
  verifiedAt: string | null
  lastStatus: string | null
  lastError: string | null
}

export interface SessionStatus {
  status: string
  lastError: string | null
}

export async function createIdentitySession(token: string): Promise<{ clientSecret: string }> {
  const response = await fetch(`${api.baseURL}/api/identity/create-session`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Failed to create session' }))
    throw new Error(err.error || 'Failed to create verification session')
  }
  return response.json()
}

export async function getIdentityStatus(token: string): Promise<IdentityStatus> {
  const response = await fetch(`${api.baseURL}/api/identity/status`, {
    headers: { 'Authorization': `Bearer ${token}` },
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Failed to get status' }))
    throw new Error(err.error || 'Failed to get identity status')
  }
  return response.json()
}

export async function getSessionStatus(token: string): Promise<SessionStatus> {
  const response = await fetch(`${api.baseURL}/api/identity/session-status`, {
    headers: { 'Authorization': `Bearer ${token}` },
  })
  if (!response.ok) {
    const err = await response.json().catch(() => ({ error: 'Failed to get session' }))
    throw new Error(err.error || 'Failed to get session status')
  }
  return response.json()
}
